<!--高级Select组件=。。尽可能适配多数场景-灵活的-->
<template>
  <div class="cargo-advance-select-wrapper">
    <el-select
      v-if="!selectDisabled || multiple"
      ref="advanceSelectRef"
      v-model="value"
      :class="[canCopy?'can-copy':null]"
      :popper-class="`cargo-advance-select ${popperClass}`"
      :style="{position:'relative'}"
      :remote-method="remoteMethod"
      :loading="loading"
      :remote="remote"
      :filter-method="localFilterMethod"
      :placeholder="placeholderText"
      :clearable="clearable"
      :multiple="multiple"
      :filterable="remote||filterable"
      size="mini"
      reserve-keyword
      :automatic-dropdown="automaticDropdown"
      :disabled="selectDisabled"
      default-first-option
      @keydown.native.enter.prevent="onEnter"
      @focus="onFocus"
      @blur="onBlur"
      @change="onChange"
      @clear="toClear"
      @visible-change="onVisibleChange"
    >
      <!--远端或者需要过滤，则显示title提示-->
      <div
        v-if="canShowOptions.length>0&&(remote||filterable)"
        value="00000000"
        :disabled="1===1"
        class="tip-count-options"
      >
        <div
          v-if="page"
          style="height: 100%;padding-left:15px;padding-top: 12px;"
        >{{
          page ? `${$t('CargoMsg.Cargo_EachPage')} ${pageSize}${$t('CargoMsg.Cargo_Pcst')},` : ''
        }}{{ $t('Message.TotalCost1') }}{{ totalCount }}{{ $t('CargoMsg.Cargo_DataBar') }}
        </div>
        <div
          v-else
          style="height: 100%;padding-left:15px;padding-top: 12px;"
        >{{ $t('CargoMsg.Cargo_BeforeCurrentDisplay') }}{{ totalCount }}{{ $t('CargoMsg.Cargo_DataBar') }}
        </div>
        <cargo-pagination
          v-if="page&&totalCount>0"
          mini
          :total="totalCount"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="getPageData"
        />
      </div>
      <div
        v-if="canShowOptions.length>0&&(remote||filterable)"
        value="00000001"
        style="font-size:12px;height:34px;color:#545557"
      >{{ $t('Message.Occupies') }}
      </div>
      <template v-for="(item,index) in options">
        <el-option
          v-if="showOptions || item[ownTagValue] === defaultValue || multiple"
          :key="prefixNo+'-'+item[ownTagValue]+'-'+index"
          :index="index"
          :style="getOptionStyle(item, index)"
          :disabled="(firstHeader && index === 0)||(actionableOption&&!actionableOption(item))"
          :label="getLabel(item)"
          :value="item[ownTagValue]"
        >
          <slot
            v-if="(!customLabel|| !showCustomLabelInOption)&&!customLabelTypes.includes(selectType)"
            :option="{item:item,fields:ownFields}"
          >
            <div
              v-if="shouldUseResolvedLabelInOption()"
              :title="getLabel(item)"
              :style="{'font-size':'12px',overflow: 'hidden','text-overflow':'ellipsis','white-space': 'nowrap','text-align': 'left','padding':'0 5px','min-width': '110px','margin-right':'20px'}"
            >
              {{ getLabel(item) }}
            </div>
            <div
              v-else
              :style="{'display': 'flex','justify-content': 'space-between','min-width':'110px','margin-right':'20px'}"
            >
              <div
                v-for="(field) in ownFields"
                :key="field"
                :title="item[field] || item[ownTagName]"
                :style="{'flex':1,'font-size':'12px',overflow: 'hidden','text-overflow':'ellipsis','white-space': 'nowrap','text-align': 'left','padding':'0 5px','min-width': '70px'}"
              >
                {{ ownFields.length > 1 ? (item[field] + ' ' || item[ownTagName]) : (item[ownTagName]) }}
              </div>
            </div>
          </slot>
        </el-option>
      </template>
    </el-select>
    <el-input
      v-else
      ref="elInput"
      :class="[canCopy?'can-copy':null]"
      disabled
      :value="disabledLabel"
      :placeholder="!disabledLabel ? placeholderText : ''"
    />
    <el-tooltip
      :content="$t('CargoMsg.Cargo_Copy')"
      placement="top"
    >
      <el-link
        v-if="canCopy"
        class="copy-icon"
        :class="[isFocus?'is-focus':'']"
        :underline="false"
        @click="handleCopy"
      >
        <i class="el-icon-document-copy" /></el-link>
    </el-tooltip>
  </div>
</template>

<script>
import request from '@/utils/request'
import { AdvanceSelect, getCacheData, getCacheItem } from '@/utils/class/AdvanceSelect'
import { basicCacheKeys as TYPE_NAMES, localCacheKeyPrefix } from '@/utils/cacheConfig'
import qs from 'qs'
import lodash from 'lodash'
import { sortByMultiField } from '@/utils'
import escapeStringRegexp from 'escape-string-regexp'
import ColumnUtils from '@/utils/ColumnUtils'
import { resolveSpecificField2Item, resolveSpecificField2ItemByCustomType } from '@/utils/basicDataCache'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

const latestUsedValuesMap = new Map() // 最近使用的值的map
let lastTriggeredAt // 用户远程搜索（记录最后一次触发时间）
let isRefreshingCache = false // 是否正在刷新缓存
export default {
  name: 'CargoAdvanceSelect',
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  props: {
    handTriggerValue: { type: [String, Number], default: 1 }, // 手动触发开关值-watched
    dataFilterFunction: { type: Function, required: false }, // options项数据过滤函数
    searchDataFilterFunction: { type: Function, required: false }, // options项数据过滤函数
    includeAllItem: { type: Boolean, default: false }, // 是否包含全部选项
    initNotify: { type: Boolean, default: false }, // 是否进行初始化通知(渲染完毕后触发)
    selectType: { type: String, default: '' }, // 下拉控件类型(缓存key)
    page: { type: Boolean, default: false }, // 是否启用分页(todo 目前只支持本地数据)
    pageSize: { type: Number, default: 10 }, // 下拉列表的显示数量
    disabled: { type: Boolean, default: false }, // 不可编辑
    allowFetch: { type: Boolean, default: true }, // 是否让该组件去调取接口
    optionsWidth: { type: String, default: null }, // options下拉框宽度 old:450px
    optionsColumnWidth: { type: String, default: '100%' }, // options下拉框每一行列的宽度
    cache: { type: Boolean, default: true }, // （相关数据，是否为缓存数据《前端是否有缓存处理逻辑》）
    remote: { type: Boolean, default: false }, // （是否为远程搜索组件）-- todo 注意：远程搜索，后期准备废弃 ，因为 编辑时 回显值需要做更多的处理 等
    clearable: { type: Boolean, default: true }, // （是否有清空按钮操作）
    allowCreate: { type: Boolean, default: false }, // （是否允许创建新条目进行选择）-- 测试通过(目前只支持 本地数据，不支持remote) .如果为true，则filterable 也要为true
    filterable: { type: Boolean, default: false }, // （是否允许过滤）--
    filterTagNames: {
      type: Array, default: () => {
        return []
      }
    }, // 参与非远程搜索时 过滤的 字段名称 （如果长度为0，默认根据tagName过滤）
    filterType: {
      type: String, default: () => {
        return ''
      }
    }, // 参与非远程搜索时 过滤的 模式 left 最左匹配，global全量匹配
    multiple: { type: Boolean, default: false }, // （是否多选）
    showCopy: { type: Boolean, default: true }, // 是否显示复制
    placeholder: { type: String, default: '' },
    wait: { type: Number, default: 200 }, // 远程搜索间隔时间
    tagName: { type: String, default: '' }, // 要取来显示到select框内的字段名
    tagValue: { type: String, default: '' }, // select的value对应的字段，默认id
    url: { type: String, default: '' }, // 请求数据的url（会优先 根据url去远端获取数据）
    defaultValue: { type: [String, Number, Boolean], default: '' }, // 默认值(multiple的话，defaultMultipleValue 一定要传值)-与defaultMultipleValue互斥(remote或者单选使用这个defaultValue默认值)
    defaultMultipleValue: {
      type: [Array, String], default: () => {
        return []
      }
    }, // 默认值(multiple的话，defaultMultipleValue 一定要传值)
    remoteDefaultObj: { type: [Object, Array], default: null }, // 远程默认实体（远程组件在编辑后，再次访问是有默认值的）
    fixedOptions: { type: Array, default: null }, // 固定的select的option
    callbackParams: { type: Object, default: null }, // 回传参数，即把父组件传递的参数原样传回（场景：table编辑rowIndex）或者一个页面需使用多个本组件
    callbackMethod: { type: String, default: 'parentCallBack' }, // 回调的方法名
    callbackMethodType: { type: String, default: 'obj' }, // 回调的方法(传给父组件监听事件值的类型)
    method: { type: Function, default: null }, // 请求数据的方法  注意：url优先级高
    methodParams: {
      type: Object, default: () => {
        return {}
      }
    }, // url或者method请求数据的方法参数 collectionType: and(并集) / or(交集)
    actionableOption: { type: Function, required: false }, // 是否可操作option的回调
    headers: { type: Array, default: () => [] }, // eg:[] 数组-options的头,有值，就说明要展示headers
    fields: { type: Array, default: () => [] }, // 下拉列表要展示的字段-options中要显示的实体的属性字段名
    staticOptions: {
      type: Array, default: () => {
        return null
      }
    }, // 指定的静态的下拉options
    remoteKeywordLength: {
      type: Number, default: () => {
        return 2
      }
    }, // 远程搜索关键词最小长度
    disabledTag: { type: Boolean, default: true },
    showOriginValue: { type: Boolean, default: false },
    popperClass: { type: String, default: null },
    customLabel: {
      type: Function,
      default: null
    },
    showCustomLabelInOption: {
      type: Boolean,
      default: true
    },
    customSelectedLabel: {
      type: String,
      default: ''
    },
    automaticDropdown: {
      type: Boolean,
      default: () => false
    },
    autoKey: {
      type: String,
      default: () => null
    },
    receivable: {
      type: Boolean,
      default: () => null
    },
    clearNotMatch: { // 匹配不到选项，则清空
      type: Boolean,
      default: false
    },
    dataOption: { type: Object, default: null },
    zeroCanCopy: {
      type: Boolean,
      default: () => false
    },
    useTagNameAtMultiple: { type: Boolean, default: false }, // 多选模式下，按照tagName显示
    filterAfterFetchData: { type: Boolean, default: false }, // 是否在获取数据后，执行过滤方法（localFilterMethod）
    staticComponent: {
      type: Object,
      default: null
    },
    latestUsedDataKey: { type: String, default: '' } // 最近使用的数据缓存key
  },
  data() {
    return {
      showOptions: false,
      initNotifyDone: false, // 初始化通知是否完成
      advanceSelect: null,
      pageNum: 1,
      primitiveOptions: [], // 为本地加载的数据保留一份副本
      options: [],
      filterOptions: [], // 本地过滤后的数据集合
      value: '',
      loading: true,
      ownUrl: '',
      ownTagName: '',
      ownTagValue: '',
      ownHeaders: [],
      ownFields: [],
      ownFilterTagNames: [],
      ownFilterType: '',
      isFocus: false,
      inputValue: '',
      disabledLabel: '',
      customLabelTypes: [
        TYPE_NAMES.basic_data_Company,
        TYPE_NAMES.basic_data_Seaport,
        TYPE_NAMES.basic_data_Airport,
        TYPE_NAMES.basic_data_RailwayStation,
        'static_data_User',
        TYPE_NAMES.basic_data_User, /*,
        TYPE_NAMES.basic_data_Vessel*/
        TYPE_NAMES.basic_data_VehicleModel,
        TYPE_NAMES.basic_data_CutomJobType
      ],
      prefixNo: 1 // 前缀编号（拼接到el-option的key中，用于强制刷新）
    }
  },
  computed: {
    defaultPlaceholder() {
      return this.placeholder || this.$t('common.defaultPlaceholder')
    },
    normalizedDefaultMultipleValue() {
      // 确保 defaultMultipleValue 始终返回数组
      if (Array.isArray(this.defaultMultipleValue)) {
        return this.defaultMultipleValue
      }
      // 如果是字符串，尝试解析或返回空数组
      if (typeof this.defaultMultipleValue === 'string') {
        if (this.defaultMultipleValue === '') {
          return []
        }
        // 如果是 JSON 字符串，尝试解析
        try {
          const parsed = JSON.parse(this.defaultMultipleValue)
          return Array.isArray(parsed) ? parsed : [this.defaultMultipleValue]
        } catch (e) {
          // 如果不是 JSON，当作单个值处理
          return [this.defaultMultipleValue]
        }
      }
      return []
    },
    canCopy() {
      return !this.multiple && this.showCopy && (this.value || this.disabledLabel || (this.value === 0 && this.zeroCanCopy))
    },
    canShowOptions() {
      return this.options ? this.options.filter(p => !p.notShowInOptions) : this.options
    },
    totalCount() {
      // todo 根据header需要 减一
      let count = 0
      if (this.remote || !this.page) {
        count = this.canShowOptions ? this.canShowOptions.length : 0
      } else {
        count = this.filterOptions ? this.filterOptions.filter(p => !p.notShowInOption).length : 0
      }
      return this.firstHeader ? count - 1 : count
    },
    headerOptionStyle() {
      const showHeader = (this.remote || this.filterable) && this.firstHeader && this.canShowOptions && this.canShowOptions.length > 1

      return {
        position: (showHeader ? 'absolute' : ''),
        top: (showHeader ? '30px' : ''),
        left: 0,
        right: 0,
        background: ((this.firstHeader) ? '#fcfcfc' : ''),
        'z-index': ((this.firstHeader) ? '1000' : '')
      }
    },
    firstNormalOptionStyle() {
      // 需考虑 自动创建item的样式处理
      const isNormalFirstOption = (this.remote || this.filterable) && this.firstHeader

      return { 'margin-top': (isNormalFirstOption ? '25px' : '-5px') }
    },
    firstHeader() {
      if (this.showCustomLabelInOption) {
        return null
      }
      // 用来动态生成options的头
      const fields = this.ownFields
      let firstHeader = null
      if (this.ownHeaders && this.ownHeaders.length > 0) {
        firstHeader = {}
        lodash.forEach(this.ownHeaders, (item, index) => {
          firstHeader[fields[index]] = item
        })
        // firstHeader[this.ownTagValue]一定要有值，否则在options循环时 会吃内存（element内部的问题，暂时没搞清楚）
        // firstHeader[this.ownTagValue] = firstHeader[this.ownTagValue] || new Date() + ''
        firstHeader.headerOption = true
      }
      return firstHeader
    },
    emptyItem() {
      const emptyItem = {}
      this.ownFields.forEach(item => {
        emptyItem[item] = ''
      })
      emptyItem[this.ownTagValue] = this.multiple ? [] : ''
      return emptyItem
    },
    cacheLoaded() {
      return this.$store.state.cache.cacheLoadingStatus
    },
    selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled
    },
    placeholderText() {
      if (!this.multiple || this.selectDisabled) {
        return this.defaultPlaceholder
      }
      // 处理多选下拉时，数据不为空、提醒值与下拉值混合显示问题
      return (this.multiple && (!this.value || this.value.length === 0)) ? this.defaultPlaceholder : ''
    }
  },
  watch: {
    selectDisabled() {
      this.initComponent(false)
    },
    // todo 在此 需要监听 分公司的变化，（根据配置）统一处理 和公司有关的缓存数据
    handTriggerValue(newVal, oldVal) {
      if (newVal === oldVal) return
      this.initComponent(false)
    },
    defaultValue(newVal, oldVal) {
      // if (!this.options || this.options.length <= 0) {
      // 为了设置默认值-默认项
      // this.initComponent() // 如需解决 远程默认第一项的问题，可注释该行代码-未测试
      // 1、如果执行会出现问题（1、像用户组件，返回的value，
      // 但是该方法实现中 需要去拼 remoteDefaultObj《里面没chineseName>的options,就会有问题<options里显示id而不是名称>。
      // callbackMethodType为obj的，remoteDefaultObj包含的比较多（有chineseName等）
      // 非远程搜索不涉及 remoteDefaultObj，所以没关系，也可以执行 initComponent（非远程搜索执行此initComponent，还可以解决toClear-》options=[]后的重新赋值问题）
      // 2、如果 注释这一句，像编辑进入的页面，如:结算单位的 远程默认<remoteDefaultObj>值赋不上去。所以下边根据情况判断）
      // this.$logger.log('watch defaultValue=', data, ' ===initComponent()===')

      if (newVal === oldVal) return
      this.initComponent(false)
      // 默认值发生变化，需要 fetchData(data)--注意：-data 是value不是label
      // }
    },
    allowCreate(newVal, oldVal) {
      if (newVal === oldVal) return
      this.initComponent(false)
    },
    selectType(newVal, oldVal) {
      if (newVal === oldVal) return
      this.initComponent()
    },
    defaultMultipleValue(newVal, oldVal) {
      if (!this.multiple) {
        return
      }
      if ((!this.remote) || this.callbackMethodType === 'obj') {
        if (lodash.isEqual(newVal, oldVal)) return
        this.initComponent(false)
      }
    },
    methodParams(newVal, oldVal) {
      // 此处需要判断，暂未调试出 methodParams被fired的原因 todo
      if (lodash.isEqual(newVal, oldVal)) return
      console.log('method-params', newVal)
      this.initComponent()
    },
    staticOptions(newVal, oldVal) {
      if (lodash.isEqual(newVal, oldVal)) return
      this.initComponent(false)
    },
    async cacheLoaded(val) {
      if (val && this.cache) {
        console.log('watchCache', val)
        if (!this.selectType.startsWith(localCacheKeyPrefix)) {
          const loadingCacheKey = this.$store.state.cache.loadingCacheKey
          if (loadingCacheKey && loadingCacheKey === this.selectType) {
            await ensureExecuteSuccess(() => !isRefreshingCache)
            isRefreshingCache = true
            this.initComponent(false)
            setTimeout(() => {
              isRefreshingCache = false
            })
          }
        }
      }
    },
    options(val) {
      if (!val || val.length === 0) {
        return
      }
      this.setHoverIndex()
      const value = this.defaultValue

      if (value || value === 0) {
        this.$nextTick(() => {
          const select = this.$refs.advanceSelectRef
          if (!this.showOriginValue && !this.allowCreate && select && val.findIndex(item => item[this.ownTagValue] === value) < 0 && select.selectedLabel == value) {
            select.selectedLabel = ''
            select.selected = {
              currentLabel: this.customSelectedLabel || '',
              value: value
            }
          }
        })
      }
    },
    '$store.state.settings.partnerLabelSettings': {
      handler: function() {
        this.setDisabledLabel()
      },
      deep: true
    },
    clearNotMatch(val) {
      if (val) {
        this.checkMatchOption()
      }
    }
  },
  beforeCreate() {
    // const selectType = 'static_data_Title'
    // this.$logger.filterRule((content) => {
    //   if (!content.includes(selectType)) {
    //     return true
    //   }
    //   return false
    // })
  },
  created() {
    // this.$logger.appendPrefix('::' + this.selectTypeNames)
    // if (!this.optionsWidth) {
    //   this.optionsWidth = 150 + (this.fields.length * 200) + 'px'
    // }
  },
  mounted() {
    // this.$logger.log('mounted ', `selectType:${this.selectType};multiple:${this.multiple};defaultMultipleValue:${this.defaultMultipleValue} ${typeof this.defaultMultipleValue};defaultValue:${this.defaultValue}`, this.methodParams)
    if (this.remote) {
      // 远程的 都过滤
      // this.filterable = true
    }
    this.initComponent()
  },
  beforeDestroy() {
    this.advanceSelect.clear()
    this.advanceSelect = null
  },
  methods: {
    getlatestUsedValues() {
      if (this.latestUsedDataKey) {
        let latestUsedValues = latestUsedValuesMap.get(this.latestUsedDataKey)
        if (!latestUsedValues) {
          latestUsedValues = LocalStorageUtilsNew.getConfiguration(this.latestUsedDataKey) || []
          latestUsedValuesMap.set(this.latestUsedDataKey, latestUsedValues)
        }
        return latestUsedValues
      }
      return null
    },
    setLatestUsedValues(values) {
      if (this.latestUsedDataKey) {
        latestUsedValuesMap.set(this.latestUsedDataKey, values)
        LocalStorageUtilsNew.setConfiguration(this.latestUsedDataKey, values)
      }
    },
    setDisabledLabel() {
      const { selectDisabled, options, ownTagValue, defaultValue, ownTagName, multiple, staticOptions } = this
      let { selectType } = this

      if (selectDisabled && !multiple) {
        if (ownTagName === ownTagValue) {
          this.disabledLabel = defaultValue
          return
        }
        if (!defaultValue && defaultValue !== 0 && defaultValue !== false) {
          this.disabledLabel = ''
          return
        }
        if (selectType) {
          if (selectType === TYPE_NAMES.basic_data_PaymentTerm) {
            const item = resolveSpecificField2Item(selectType, ownTagValue, defaultValue)
            this.disabledLabel = item ? this.getPaymentTermLabel(item) : ''
            return
          }
          if (this.customLabelTypes.includes(selectType)) {
            if (selectType === 'static_data_User') {
              selectType = TYPE_NAMES.basic_data_User
            } else if (selectType === 'basic_data_CutomJobType') {
              selectType = TYPE_NAMES.basic_data_CutomJobType
            }
            let item = {}
            if (selectType === 'basic_data_CutomJobType') {
              item = resolveSpecificField2ItemByCustomType(selectType, ownTagValue, defaultValue, this.methodParams.type)
            } else {
              item = resolveSpecificField2Item(selectType, ownTagValue, defaultValue)
            }
            console.log(selectType, item, defaultValue)
            if (item) {
              this.disabledLabel = this.getLabel(item)
              return
            } else {
              this.disabledLabel = '' // CARGO-17726，结算单位未匹配上时，disabledLabel 没有清空
            }
          }
          let isNeedObject = false
          if (this.selectType === TYPE_NAMES.basic_data_CustomerSource) {
            isNeedObject = !isNeedObject
          }
          const label = ColumnUtils.resolveColumnLabel(selectType, ownTagValue, defaultValue, ownTagName, isNeedObject)
          if (label) {
            if (selectType === TYPE_NAMES.basic_data_CustomerSource) {
              this.disabledLabel = ('(' + (label.code ? label.code : '') + ') ') + (label.name ? label.name : '')
            } else {
              this.disabledLabel = label
            }
            return
          } else {
            this.disabledLabel = '' // CARGO-20573，切换分录时 界面会显示上一个选中分录的“部门”
          }
        }
        const opt = (staticOptions || options).find(option => {
          return option[ownTagValue] === defaultValue
        })
        if (opt) {
          this.disabledLabel = this.getLabel(opt)
        }
      } else {
        this.disabledLabel = ''
      }
    },
    getPageData() {
      this.localPageQuery(true)
    },
    /**
     * 本地分页函数，和远程无关
     * page 是否本地分页
     **/
    localPageQuery(page) {
      // 大数据的情况，可以赋值第一页 todo 不分页情况 最大显示50条，你可以精确查询条件
      const max = this.firstHeader ? 51 : 50
      const start = page ? (this.pageNum - 1) * this.pageSize : 0
      const count = page ? this.pageSize : max
      // if (this.primitiveOptions && this.primitiveOptions[0].headerOption) {
      //   ++start
      //   ++end
      // }
      this.options = []
      for (let i = start - 1; i >= 0; --i) {
        if (this.filterOptions[i].notShowInOption) {
          this.options.push(this.filterOptions[i])
        } else {
          break
        }
      }
      this.options.reverse() // 调整顺序
      let num = 0
      for (let i = start; i < this.filterOptions.length; ++i) {
        if (this.filterOptions[i].notShowInOption) {
          this.options.push(this.filterOptions[i])
        } else {
          if (num < count) {
            this.options.push(this.filterOptions[i])
            num += 1
          } else {
            break
          }
        }
      }
    },
    localFilterMethod(keyword) { // 非远程搜索数据的过滤方式
      // 空格 需要触发 查询全部
      // if (!keyword.trim()) {
      //   return
      // }
      this.prefixNo += 1
      const regText = keyword.replace(/(^\s*)/g, '')
      this.loading = true
      let filters = null
      if (regText === '') {
        filters = this.primitiveOptions
      } else {
        // todo 优化大数据的本地过滤
        filters = this.getFilterData(regText)
      }
      if (this.ownHeaders && this.ownHeaders.length > 0 && filters && filters.length === 1 && !this.showCustomLabelInOption) {
        // if ((this.ownHeaders && this.ownHeaders.length > 0 && filters.length <= 1)) {
        // 说明filters中仅有的一条数据时 options的title。相当于没真实数据
        // if (this.allowCreate) {
        //   const emptyItem = { ...this.emptyItem }
        //   // 说明是 新创建的
        //   emptyItem[this.ownTagValue] = keyword
        //   emptyItem[this.ownTagName] = keyword
        //   filters.push(emptyItem)
        //   this.primitiveOptions.push({ ...emptyItem })
        // } else {
        //   filters = []
        // }
        filters = []
      }
      if (filters instanceof Array) {
        let currValues
        if (this.multiple) {
          currValues = this.value || this.normalizedDefaultMultipleValue
        } else {
          currValues = [this.value || this.defaultValue]
        }
        if (currValues instanceof Array) {
          const newFilters = []
          const frontItems = []
          let headerItem
          filters.forEach(item => {
            if (item.headerOption) {
              headerItem = item
              return
            }
            if (!currValues.includes(item[this.ownTagValue])) {
              newFilters.push(item)
            } else {
              frontItems.push(item)
            }
          })
          const sortedFrontItems = []
          for (const currValue of currValues) {
            const frontItem = frontItems.find(p => p[this.ownTagValue] === currValue)
            if (frontItem) {
              sortedFrontItems.push(frontItem)
            }
          }
          newFilters.unshift(...sortedFrontItems)
          if (headerItem) {
            newFilters.unshift(headerItem)
          }
          filters = newFilters
        }
      }
      this.filterOptions = filters
      this.pageNum = 1
      this.localPageQuery(this.page)
      this.loading = false
    },
    getFilterData(keyword) {
      let filterTagNames = null
      if (this.ownFilterTagNames && this.ownFilterTagNames.length !== 0) {
        filterTagNames = this.ownFilterTagNames
      } else {
        filterTagNames = [this.ownTagName]
      }
      const reg = new RegExp(`^${escapeStringRegexp(keyword.toLowerCase())}.*$`, 'i')
      const regGlobal = new RegExp(`${escapeStringRegexp(keyword.toLowerCase())}.*`, 'i')
      let result = []
      if (filterTagNames) {
        for (let i = 0; i < filterTagNames.length; i++) {
          const tagName = filterTagNames[i]
          const leftMatch = this.filterData(keyword, tagName, reg)
          result = result.concat(sortByMultiField(leftMatch, [this.ownTagName], false))
          if (this.ownFilterType === 'global') {
            const globalMatch = this.filterData(keyword, tagName, regGlobal)
            result = result.concat(globalMatch)
          }
        }
      }
      if (this.allowCreate && keyword && !result.find(item => item[this.ownTagValue] === keyword || item[this.ownTagName] === keyword)) {
        const customOption = {}
        customOption[this.ownTagName] = keyword
        customOption[this.ownTagValue] = keyword
        result.unshift(customOption)
      }
      if (this.firstHeader && this.ownHeaders && this.ownHeaders.length > 0 && result.length > 0) {
        result.unshift(this.firstHeader)
      }
      return Array.from(new Set(result))
    },
    filterData(keyword, tagName, reg) {
      const data = []
      this.primitiveOptions.forEach((item) => {
        if (item[tagName] && String(item[tagName]).trim().toLowerCase().match(reg)) {
          if (this.advanceSelect.isCustomFilter) {
            if (this.advanceSelect.matchFilterCondition(item, keyword)) {
              data.push(item)
            }
          } else {
            data.push(item)
          }
        }
      })
      return data
    },
    remoteMethod(keyword) {
      // keyword.trim()后为空，就不会进入这个方法
      if (keyword.trim().length >= this.remoteKeywordLength) {
        lastTriggeredAt = new Date().getTime()
        setTimeout(() => {
          const now = new Date().getTime()
          if ((now - this.wait) >= lastTriggeredAt) { // 严格来说，应该用===
            // this.loading = true （设置为true，远程加载数据有延迟，那么 将this.loading 置位 false也有延时。这些因素会导致 下拉列表抖动）
            if (this.allowFetch) {
              this.fetchData(keyword).then(result => {
                if (result === 'success') { // 远程搜索默认选择 第一项
                  this.toChooseFirstOption()
                }
              })
            } else {
              this.loading = false
            }
          } // 这个if判断用于：在this.wait长度的时间内，如果再次输入触发了setOptions，则会令“上一次”搜索不执行(因为本次改写了lastTriggeredAt的值)
        }, this.wait)
      }
    },
    clearData() {
      this.options = []
    },
    fillData(defaultOptions) { // 填充数据
      this.options = [...defaultOptions]
    },
    fetchData(keyword, forceSearchAll) { // Boolean forceSearchAll 强制查询（该值为true，则说明强制走toQuery）
      // this.methodParams.keyword = keyword
      this.loading = true
      if ((!forceSearchAll) && !keyword) { // 如果keyword没有输入东西 ,todo
        this.value = ''
        this.toClear()
        this.loading = false
        return Promise.resolve('success')
      }
      let queryMethod
      if (this.staticOptions) {
        // 静态数据
        const res = { ok: true, data: this.staticOptions }
        if (this.staticComponent && this.methodParams && this.staticOptions && this.staticOptions.length > 0) {
          res.data = this.staticOptions.filter(item => {
            return this.staticComponent.addToMap(item, this.methodParams, null)
          })
        }
        queryMethod = Promise.resolve(res)
      } else if (this.cache) {
        // 远端缓存or 本地常量
        if (this.advanceSelect.isFindTypeInfo()) {
          const inputVal = this.clearNotMatch ? null : this.defaultValue
          queryMethod = getCacheData(this.selectType, this.advanceSelect, inputVal)
        } else {
          const message = 'selectType=' + this.selectType + ' not found, No selectType configuration found in AdvanceSelect.js,return empty array,eg:[]'
          queryMethod = Promise.resolve({ ok: false, data: [], message })
          // this.$logger.warn(message)
        }
      } else {
        queryMethod = this.toQuery(keyword)
      }
      if (!queryMethod) {
        const res = { ok: true, data: [{ [this.ownTagName]: this.$t('Message.DataLoadingFailed') }] }
        queryMethod = Promise.resolve(res)
      }
      // this.$logger.error('const queryMethod', queryMethod, 'isCache=' + this.cache , this.selectType)
      return queryMethod.then(res => {
        // console.log('select-result', res)
        let resOptions = [] // 定义临时变量的目的是为了防止数据量过大 导致select挂掉
        // this.$logger.log('isCache=' + this.cache + 'resDatas= ', res)
        // this.$logger.log('this.methodP', this.methodParams)
        // 这个地方res.ok 需要，因为有的是模拟请求
        if (res.ok) {
          if ((res.data && res.data.length > 0) || (res.data.list && res.data.list.length > 0)) {
            const options = res.data.list || res.data
            resOptions = options.filter(item => {
              const { ownTagValue } = this
              const value = item[ownTagValue]
              return item && value !== null && value !== '' && value !== 'undefine'
            })
            resOptions = this.adjustOptionsOrder(resOptions)
            if (this.latestUsedDataKey) {
              resOptions = this.adjustLatestUsedDataOrder(resOptions)
            }
            // 将对应tagValue的值转为string #listTargetVal-Convert-String 2020/9/12 不转字符串，传的什么就是什么
            // resOptions.forEach(p => p[this.ownTagValue] = String(p[this.ownTagValue]))
            // 固定options

            if (this.allowCreate) {
              if (this.multiple) {
                const { value } = this
                value.forEach((item) => {
                  if (!resOptions.find((opt) => opt[this.ownTagName] === item || item[this.ownTagValue] === item)) {
                    const customOption = {}
                    customOption[this.ownTagName] = item
                    customOption[this.ownTagValue] = item
                    resOptions.unshift(customOption)
                  }
                })
              } else {
                const { value } = this
                if (value !== '' && !resOptions.find((item) => item[this.ownTagName] === value || item[this.ownTagValue] === value)) {
                  const customOption = {}
                  customOption[this.ownTagName] = value
                  customOption[this.ownTagValue] = value
                  resOptions.unshift(customOption)
                }
              }
            }
            if (this.fixedOptions) {
              resOptions.unshift(...this.fixedOptions)
              // this.$logger.log('this.options fixedOptions', resOptions)
            }
          } else {
            this.options = []
            resOptions = []
            this.primitiveOptions = []
          }
          if (resOptions && resOptions.length > 0) {
            // 默认选中第一行
            // if (!this.remote) {
            //   // 先不考虑 远程搜索 默认赋值的情况 todo
            //   this.value = resOptions[0][this.ownTagValue]
            //   this.toNotify(resOptions[0])
            // }

            if (this.ownHeaders && this.ownHeaders.length > 0 && this.firstHeader) {
              resOptions.unshift(this.firstHeader)
            }
            // 赋值 primitiveOptions(为本地加载的数据保留一份副本，用于本地查询使用，远程查询无参考价值)
            this.primitiveOptions = resOptions
            if (this.remote) {
              // 远程查询，直接赋值
              this.options = resOptions
            }

            // 为了不影响性能，做如下分支处理
            if (this.selectType.startsWith(localCacheKeyPrefix)) {
              this.$emit('localCacheOptionsChange', this.primitiveOptions)
            }
          } else {
            if (!this.remote) { // 没找到数据记录且非远程加载
              // 先不考虑 远程搜索 默认赋值的情况 todo

              // 静态数据可能异步加载赋值【对于没查找到 下拉数据集合的情况，就显示传递的defaultValue】
              // this.value = ''
              // this.toClear()
            }
          }
          this.loading = false
        } else {
          this.loading = false
          return Promise.reject(res.message)
        }
      }).then(() => {
        // todo 拉取后台数据成功
        this.afterFetchDataSuccess()
        return Promise.resolve('success')
      }).catch(err => {
        // this.$message.error(err)
        return Promise.reject(err)
      }).finally(() => {
        this.loading = false
      })
    },
    // 调整选项顺序（将勾选了“是否内部往来公司”的合作伙伴数据放在最后面）
    adjustOptionsOrder(resOptions) {
      if (this.selectType === TYPE_NAMES.basic_data_Company || this.selectType === TYPE_NAMES.static_data_Company) {
        const internalCorrespondentData = resOptions.filter(item => item.internalCorrespondent)
        if (internalCorrespondentData.length > 0) {
          const otherData = resOptions.filter(item => !item.internalCorrespondent)
          return [...otherData, ...internalCorrespondentData]
        }
      }
      return resOptions
    },
    adjustLatestUsedDataOrder(resOptions) {
      const latestUsedValues = this.getlatestUsedValues()
      if (latestUsedValues && latestUsedValues.length > 0) {
        const newResOptions = []
        const latestUsedData = resOptions.filter(item => latestUsedValues.includes(item[this.ownTagValue]))
        for (const usedValue of latestUsedValues) {
          const latestUsedItem = latestUsedData.find(item => item[this.ownTagValue] === usedValue)
          if (latestUsedItem) {
            newResOptions.push(latestUsedItem)
          }
        }
        const otherData = resOptions.filter(item => !latestUsedValues.includes(item[this.ownTagValue]))
        newResOptions.push(...otherData)
        return newResOptions
      }
      return resOptions
    },
    afterFetchDataSuccess() {
      // this.$emit('currDataArr', lodash.cloneDeep(this.primitiveOptions))
      this.resetOptions()
      if (this.clearNotMatch) {
        this.$nextTick(() => {
          this.checkMatchOption()
        })
      }
      if (this.filterAfterFetchData && this.$refs.advanceSelectRef.query) {
        this.localFilterMethod(this.$refs.advanceSelectRef.query)
      }
    },
    resetOptions() {
      // if (!this.remote && this.filterable) {
      if (!this.remote) {
        // todo 需要考虑 编辑场景下，默认值赋值问题.因为分页后，可能当前页不包含defaultValue
        // 还要考虑多选分页的情况
        let currValues
        if (this.multiple) {
          currValues = this.value || this.normalizedDefaultMultipleValue
        } else {
          // currValues = [String(this.value) || String(this.defaultValue)]
          currValues = [(this.value) || (this.defaultValue)]
        }
        if (currValues) {
          const tempPrimitiveOptions = []
          const frontItems = []
          let headerItem
          this.primitiveOptions.forEach(item => {
            if (item.headerOption) {
              headerItem = item
              return
            }
            if (!currValues.includes(item[this.ownTagValue])) {
              tempPrimitiveOptions.push(item)
            } else {
              frontItems.push(item)
            }
          })
          const sortedFrontItems = []
          for (const currValue of currValues) {
            const frontItem = frontItems.find(p => p[this.ownTagValue] === currValue)
            if (frontItem) {
              sortedFrontItems.push(frontItem)
            }
          }
          tempPrimitiveOptions.unshift(...sortedFrontItems)
          if (headerItem) {
            tempPrimitiveOptions.unshift(headerItem)
          }
          this.filterOptions = tempPrimitiveOptions
        } else {
          this.filterOptions = this.primitiveOptions
        }
        this.pageNum = 1
        this.localPageQuery(this.page)
        if (this.initNotify && !this.initNotifyDone) {
          this.initNotifyDone = true
          this.$nextTick(() => {
            this.toNotify()
          })
        }
      }
      this.convertSelectedToText()
    },
    toQuery(keyword) {
      const params = { ...this.methodParams }
      if (lodash.isObject(keyword)) {
        // 对象
        Object.assign(params, keyword) // 如果是对象，就和之前的查询参数进行合并
      } else {
        // 关键字是字符串
        if (keyword && keyword.trim()) {
          // 输入的不是空格
          params.likeName = keyword
        } else {
          // 查全部
          keyword = keyword ? keyword.trim() : keyword // 去除前后空格
        }
      }
      if (this.ownUrl) {
        // 优先根据URL查询
        // this.$logger.log('this.getURLRequestParams(params)', this.getURLRequestParams(params))
        return request(this.getURLRequestParams(params))
      } else {
        // 其次根据method方法查询
        // todo
        return {}
        // return this.method(params)
      }
    },
    initSelectTypeInfo(shouldInit = true) {
      if (shouldInit) {
        this.advanceSelect = new AdvanceSelect(this.selectType, this.methodParams, this.dataFilterFunction, this.searchDataFilterFunction, { includeAllItem: this.includeAllItem, dataOption: this.dataOption })
      }
      this.ownFields = (this.fields && this.fields.length) ? this.fields : this.advanceSelect.getFields()
      this.ownFilterTagNames = (this.filterTagNames && this.filterTagNames.length) ? this.filterTagNames : this.advanceSelect.getFilterFieldNames()
      this.ownFilterType = this.filterType ? this.filterType : this.advanceSelect.getFilterType()
      this.ownUrl = this.url || this.advanceSelect.getUrl()
      this.ownTagValue = this.tagValue || this.advanceSelect.getTagValue()
      this.ownTagName = this.tagName || this.advanceSelect.getTagName()
      this.ownHeaders = (this.headers && this.headers.length) ? this.headers : this.advanceSelect.getHeaders()
      if (!this.ownFields.includes(this.ownTagName)) {
        this.ownHeaders = []
      }
    },
    initComponent(shouldInit = true) {
      // todo 初始化组件信息，根据情况可进行优化(非首次，可以不再进行计算)
      this.showOptions = !!(this.showOptions && this.multiple)
      this.initSelectTypeInfo(shouldInit)

      // todo this.defaultValue可转为string,#see#listTargetVal-Convert-String 2020/9/12 不转字符串，传的什么就是什么
      this.value = this.multiple ? (this.normalizedDefaultMultipleValue || []) : (this.defaultValue)
      if (!this.selectDisabled || this.multiple || this.remote) {
        if (this.remote) {
          if (this.remoteDefaultObj) {
            if (this.remoteDefaultObj.length) {
              // remoteDefaultObj 是数组
              if (this.remoteDefaultObj[0][this.ownTagValue]) {
                // 远程组件设置默认值
                this.options = [...this.remoteDefaultObj]
                if (this.firstHeader) {
                  this.options.unshift(this.firstHeader)
                }
              }
            } else {
              // remoteDefaultObj 是对象
              if (this.remoteDefaultObj[this.ownTagValue]) {
                // this.$logger.log('this.remoteDefaultObj[this.ownTagValue]', this.remoteDefaultObj[this.ownTagValue])
                // this.$logger.log('======true if==对象=')
                // 远程组件设置默认值
                this.options = [{ ...this.remoteDefaultObj }]
                if (this.firstHeader) {
                  this.options.unshift(this.firstHeader)
                }
              }
            }
          }
          this.fetchData('', true)
        } else {
          this.fetchData('', true)
          /* // 非remote的（首次加载或者静态数据），没有options的时候才会去查询
          if (!this.options || this.options.length <= 0) {
            // this.$logger.log('this.allowFetch', this.allowFetch)
            if (this.allowFetch) {
              this.fetchData('', true)
            } else {
              // todo
            }
          } */
        }
      } else {
        if (this.clearNotMatch) {
          this.checkMatchOption()
        }
      }
      this.setDisabledLabel()
    },
    // 校验匹配项
    checkMatchOption() {
      if (this.allowCreate) {
        return
      }
      if (this.multiple) {
        if (!this.normalizedDefaultMultipleValue || this.normalizedDefaultMultipleValue.length === 0) {
          return
        }
        for (const item of this.normalizedDefaultMultipleValue) {
          const index = this.options.findIndex(p => {
            return p[this.ownTagValue] === item
          })
          if (index < 0) {
            this.value = []
            this.toClear()
            break
          }
        }
      } else {
        if (this.defaultValue === '') {
          return
        }
        const index = this.options.findIndex(p => {
          return p[this.ownTagValue] === this.defaultValue
        })
        if (index < 0) {
          this.value = ''
          this.toClear()
        }
      }
    },
    toClear() {
      // 注意：非远程加载不允许清空，因为清空后，options没东西了 todo
      this.value = this.multiple ? [] : ''
      this.inputValue = ''
      this.disabledLabel = ''
      if (this.$refs.advanceSelectRef) {
        this.$refs.advanceSelectRef.selectedLabel = ''
      }
      this.options = []
      this.toNotify(this.emptyItem)
      this.convertSelectedToText()
      this.$emit('clear')
    },
    toNotify(item1, isManualEntry = false) {
      if (((!this.value && this.value !== 0) || this.value.length <= 0) && !this.remote && this.filterable) {
        // 针对 非远程、可过滤的本地 数据进行处理
        // this.options = [...this.primitiveOptions]

        // todo
        // this.filterOptions = [...this.primitiveOptions]
        // this.localPageQuery()
      }
      let result
      const selectedItem = item1 || this.options.find(item => {
        return item[this.ownTagValue] === this.value
      }) || this.emptyItem

      // 处理多选（因为多选的情况，也不会再options里找到匹配的）
      if (this.multiple) {
        selectedItem[this.ownTagValue] = this.value
      }
      // 处理允许创建（因为allowCreate=true的情况，也不会再options里找到匹配的）
      /* if (this.allowCreate) {
        if (!selectedItem[this.ownTagValue]) {
          // 说明是 新创建的
          selectedItem[this.ownTagValue] = this.value
          selectedItem[this.ownTagName] = this.value
          // 下述代码，可以将创建的新项 临时持久化
          // this.options.push({ ...selectedItem })
          // this.primitiveOptions.push({ ...selectedItem })
        }
      }*/

      if (this.callbackMethodType === 'value') {
        result = { 'value': selectedItem[this.ownTagValue], isManualEntry }
      } else if (this.callbackMethodType === 'label') {
        result = { 'label': selectedItem[this.ownTagName], isManualEntry }
      } else {
        result = { ...selectedItem, value: selectedItem[this.ownTagValue], isManualEntry }
      }
      // 进一步精简传输数据
      // this.$logger.log('notify result=', result)
      if (this.callbackParams) {
        this.$emit(this.callbackMethod, { ...result, ...this.callbackParams })
      } else {
        if (this.callbackMethodType === 'obj') {
          this.$emit(this.callbackMethod, result)
        } else {
          this.$emit(this.callbackMethod, result.value || result.label)
        }
        // 更新最近使用的值
        if (this.latestUsedDataKey && result.value !== null && result.value !== '' && result.value !== 'undefine') {
          const latestUsedValues = this.getlatestUsedValues()
          const arr = [result.value]
          let count = 1
          if (latestUsedValues) {
            for (const item of latestUsedValues) {
              if (arr.includes(item)) {
                continue
              }
              arr.push(item)
              count++
              if (count >= 50) {
                break
              }
            }
          }
          this.setLatestUsedValues(arr)
        }
      }
    },
    getURLRequestParams(params) {
      return {
        url: this.ownUrl,
        method: 'get',
        params: params,
        paramsSerializer: params => qs.stringify({ ...params }, { arrayFormat: 'repeat' })
        // 因为是get请求，对数组类型的查询参数做下处理，使成'?range=SALES&range=OPERATORS'这样的形式
      }
    },
    onEnter() {
      this.$emit('enter')
    },
    onFocus() {
      this.isFocus = true
      this.inputValue = ''
      if (this.page) {
        // todo 分页开启状态，需要重置页码等信息
      } else {
        this.resetOptions()
      }
      this.$emit('focus')
      // this.toChooseFirstOption()
    },
    toChooseFirstOption() { // 默认选中第一项，未完善，待测试

      /* if (!this.$refs.advanceSelectRef.visible) {
        this.visible = true
      }
      const self = this
      this.$nextTick(() => {
        setTimeout(() => {
          if (self.$refs.advanceSelectRef.hoverIndex > -1) {
            // todo
          } else {
            self.$refs.advanceSelectRef.navigateOptions('next')
          }
        }, 300)
      })*/
    },
    onBlur() {
      this.isFocus = false
      // this.$logger.log('onBlurEvent,value=', this.value)
      this.inputValue = this.$refs.advanceSelectRef.query
      this.$emit('blur')
    },
    onChange(val) {
      this.inputValue = ''
      this.toNotify()
      if (this.multiple) {
        this.$refs.advanceSelectRef.query = ''
      }
    },
    onVisibleChange(e) {
      if (e) {
        this.showOptions = true
        this.setSelectedLabel()
        this.localFilterMethod('')
      } else {
        if (this.allowCreate) {
          if (!this.inputValue) {
            this.$emit('blur')
            return
          }
          const selected = this.options.find(item => item[this.ownTagValue] === this.inputValue)
          if (!selected) {
            this.$emit('blur')
            return
          } else {
            this.toNotify(selected, true)
          }
        }
      }
      this.$emit('visible-change', e)
    },
    handleCopy() {
      let select = this.$refs.advanceSelectRef || this.$refs.elInput
      let input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', select.$data.selectedLabel || select.value)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success(this.$t('SeaExport.CopySuccess'))
      }
      document.body.removeChild(input)
      select = null
      input = null
    },
    convertSelectedToText() {
      if (this.multiple && this.disabledTag) {
        this.$nextTick(() => {
          const curSelect = this.$refs.advanceSelectRef
          console.log('select', curSelect)
          let selected
          if (this.useTagNameAtMultiple) {
            selected = []
            if (this.normalizedDefaultMultipleValue && this.normalizedDefaultMultipleValue.length > 0) {
              for (const option of this.options) {
                if (this.normalizedDefaultMultipleValue.includes(option[this.ownTagValue])) {
                  selected.push(option[this.ownTagName])
                }
              }
            }
          } else {
            selected = curSelect.selected.map(item => {
              return item.$el ? item.$el.innerText.trim() : ''
            })
          }
          const tagWrapper = curSelect.$el.querySelector('.el-select__tags>span')
          const childs = tagWrapper.childNodes
          if (childs.length > 1) {
            for (let i = 0; i < childs.length; ++i) {
              if (childs[i].className.includes('el-tag--info')) {
                childs[i].style.display = 'none'
              }
            }
            if (selected.length > 0) {
              if (childs[0].className !== '') {
                const newSpan = document.createElement('span')
                newSpan.innerText = `${selected.join(',')}`
                tagWrapper.insertBefore(newSpan, tagWrapper.childNodes[0])
              } else {
                childs[0].innerText = `${selected.join(',')}`
              }
            } else {
              tagWrapper.innerHTML = '<span></span>'
            }
          } else {
            tagWrapper.innerHTML = selected.length ? `<span>${selected.join(',')}</span>` : '<span></span>'
          }
        })
      }
    },
    setHoverIndex() {
      if (!this.selectDisabled) {
        let select = this.$refs.advanceSelectRef
        if (!select) {
          return
        }
        select.hoverIndex = -1
        this.$nextTick(() => {
          if (this.firstHeader) {
            select.hoverIndex = 1
          } else {
            select.hoverIndex = 0
          }
          select = null
        })
      }
    },
    setSelectedLabel() {
      if (this.allowCreate) {
        this.$nextTick(() => {
          const select = this.$refs.advanceSelectRef
          if (select.query) {
            select.selectedLabel = select.query
          }
        })
      }
    },
    getLabel(item) {
      if (this.selectType === TYPE_NAMES.basic_data_Company) {
        const { methodParams, autoKey, receivable } = this
        if (autoKey) {
          return this.getConfigLabel(item, autoKey, receivable)
        }
        const keys = Object.keys(methodParams).filter(key => key !== 'active' && typeof methodParams[key] === 'boolean')
        if (keys.length === 1) {
          return this.getCmpLabel(keys[0], item)
        } else {
          return this.getCmpLabel(null, item)
        }
      }
      if (this.selectType === TYPE_NAMES.basic_data_User || this.selectType === 'static_data_User') {
        const { methodParams, autoKey } = this
        if (autoKey) {
          return this.getUserConfigLabel(item, autoKey)
        }
        if (this.selectType === 'static_data_User' && this.customLabel) {
          return this.customLabel(item)
        }
        const key = methodParams.shape
        if (key) {
          const userLabel = this.getUserLabel(key, item)
          if (userLabel) {
            return userLabel
          }
        }
      }
      if (this.selectType === TYPE_NAMES.basic_data_Seaport) {
        return this.getPortLabel(item, 'auto_7')
      }
      if (this.selectType === TYPE_NAMES.basic_data_Airport) {
        return this.getPortLabel(item, 'auto_8')
      }
      if (this.selectType === TYPE_NAMES.basic_data_RailwayStation) {
        return this.getPortLabel(item, 'auto_railway')
      }/*
      if (this.selectType === TYPE_NAMES.basic_data_Vessel) {
        return this.getConfigLabel(item, 'auto_14')
      }*/
      if (this.selectType === TYPE_NAMES.basic_data_PaymentTerm) {
        return this.getPaymentTermLabel(item)
      }
      if (this.selectType === TYPE_NAMES.basic_data_VehicleModel) {
        return item.englishName + '[' + item.chineseName + ']'
      }
      if (this.selectType === TYPE_NAMES.basic_data_CustomerSource) {
        if (this.customLabel) {
          return this.customLabel(item)
        }
        return '(' + (item[this.ownTagName] !== '' ? item[this.ownTagName] : (item.englishName || '')) + ') ' + (item[this.ownFields[1]] ? item[this.ownFields[1]] : '')
      }
      if (!this.customLabel) {
        return item[this.ownTagName] !== '' ? item[this.ownTagName] : (item.englishName || '')
      }
      return this.customLabel(item)
    },
    shouldUseResolvedLabelInOption() {
      return this.selectType === TYPE_NAMES.basic_data_PaymentTerm
    },
    getConfigLabel(item, autoKey, receivable = null) {
      const configs = this.$store.state.settings.partnerLabelSettings
      const curConfig = configs.find(config => config.autoKey === autoKey)
      const label = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
      switch (label) {
        case 'englishName':
          return item.englishName
        case 'chineseName':
          return item.chineseName
        case 'sortNamePlusEnglishName':
          return `[${item.cnShortName}]${item.englishName}`
        case 'sortNamePlusChineseName':
          return `[${item.cnShortName}]${item.chineseName}`
        case 'shortNamePlusChineseName':
          return `[${item.shortName}]${item.chineseName}`
        case 'code':
          return item.cnShortName
        case 'shortName':
          return item.shortName
        case 'customerSupplierNoChineseName':
          if (receivable === null) {
            let customerSupplerNo = item.externalKeyCust
            if (item.externalKeyVend) {
              if (customerSupplerNo) {
                customerSupplerNo += '|' + item.externalKeyVend
              } else {
                customerSupplerNo += item.externalKeyVend
              }
            }
            return `[${customerSupplerNo}]${item.chineseName}`
          } else {
            if (receivable) {
              const customerSupplerNo = item.externalKeyCust
              return `[${customerSupplerNo}]${item.chineseName}`
            } else {
              const customerSupplerNo = item.externalKeyVend
              return `[${customerSupplerNo}]${item.chineseName}`
            }
          }
        case 'customerNoChineseName':
          return `[${item.externalKeyCust}]${item.chineseName}`
        case 'supplierNoChineseName':
          return `[${item.externalKeyVend}]${item.chineseName}`
        case 'threeCharacterCode':
          return `[${item.cnShortName}]${item.threeCharacterCode}`
        default:
          return item[this.ownTagName]
      }
    },
    getPortLabel(item, autoKey) {
      const configs = this.$store.state.settings.partnerLabelSettings
      const curConfig = configs.find(config => config.autoKey === autoKey)
      const label = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
      switch (label) {
        case 'englishName':
          return item.englishName
        case 'chineseName':
          return item.chineseName || item.englishName
        case 'sortNamePlusEnglishName':
          return `[${item.code}]${item.englishName}`
        case 'sortNamePlusChineseName':
          return `[${item.code}]${item.chineseName || item.englishName}`
        case 'code':
          return item.code
        case 'shortName':
          return item.chineseName || item.code
        default:
          return item[this.ownTagName]
      }
    },
    getPaymentTermLabel(item) {
      const configs = this.$store.state.settings.partnerLabelSettings
      const curConfig = configs.find(config => config.autoKey === 'auto_paymentTerm')
      const label = curConfig ? Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key]) : 'name'
      switch (label) {
        case 'code':
          return item.code || ''
        case 'codePlusName':
          return item.code && item.name ? `[${item.code}]${item.name}` : (item.code || item.name || '')
        case 'localName':
          return item.localName || item.name || ''
        case 'name':
        default:
          return item.name || ''
      }
    },
    getCmpLabel(key, item) {
      switch (key) {
        case 'customer':
          return this.getConfigLabel(item, 'auto_0')
        case 'bookingAgent':
          return this.getConfigLabel(item, 'auto_1')
        case 'overseaAgent':
          return this.getConfigLabel(item, 'auto_2')
        case 'designationAgent':
          return this.getConfigLabel(item, 'auto_3')
        case 'localAgent':
          return this.getConfigLabel(item, 'auto_4')
        case 'seaCmp':
          return this.getConfigLabel(item, 'auto_5')
        case 'airCmp':
          return this.getConfigLabel(item, 'auto_6')
        case 'customsBroker':
          return this.getConfigLabel(item, 'auto_9')
        case 'warehouse':
          return this.getConfigLabel(item, 'auto_10')
        case 'truckCmp':
          return this.getConfigLabel(item, 'auto_11')
        case 'shipper':
          return this.getConfigLabel(item, 'auto_shipper')
        case 'consignee':
          return this.getConfigLabel(item, 'auto_consignee')
        case 'notify':
          return this.getConfigLabel(item, 'auto_notify')
        case 'auto_accountId':
          return this.getConfigLabel(item, 'auto_accountId', this.receivable)
        default:
          return this.getConfigLabel(item, 'auto_0')
      }
    },
    getUserConfigLabel(item, autoKey) {
      const configs = this.$store.state.settings.partnerLabelSettings
      const curConfig = configs.find(config => config.autoKey === autoKey)
      const label = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
      switch (label) {
        case 'englishName':
          return item.englishName
        case 'chineseName':
          return item.chineseName
        case 'sortNamePlusEnglishName':
          return `[${item.userId}]${item.englishName}`
        case 'sortNamePlusChineseName':
          return `[${item.userId}]${item.chineseName}`
        case 'englishNamePlusChineseName':
          return `[${item.englishName}]${item.chineseName}`
        case 'chineseNamePlusEnglishName':
          return `[${item.chineseName}]${item.englishName}`
        default:
          return item[this.ownTagName]
      }
    },
    getUserLabel(key, item) {
      switch (key) {
        case 'op':
          return this.getUserConfigLabel(item, 'auto_op')
        case 'csr':
          return this.getUserConfigLabel(item, 'auto_csr')
        case 'sales':
          return this.getUserConfigLabel(item, 'auto_sales')
        default:
          return item[this.ownTagName]
      }
    },
    getOptionStyle(option, index) {
      if (index === 0) {
        return [this.headerOptionStyle]
      } else if (option.notShowInOptions) {
        return [{ display: 'none' }]
      } else if (this.canShowOptions.length > 1 && this.canShowOptions[1] === option) {
        return [this.firstNormalOptionStyle]
      } else {
        return []
      }
    }
  }

}

</script>
<style scoped>
.cargo-advance-select .fixed-options {
  position: absolute !important;
  top: 60px !important;
  background: #f0f0f0 !important;
  z-index: 1000 !important;
}

.cargo-advance-select .tip-count-options {
  display: flex;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  font-size: 12px;
  color: #545557;
  height: 36px;
  position: absolute;
  top: 0px;
  background: #fcfcfc;
  z-index: 1000
}

.cargo-advance-select .normal-first-options {
  margin-top: 60px;
}
</style>
<style lang="scss">
@import "~element-ui/packages/theme-chalk/src/common/var.scss";
@import "~@/styles/element-variables.scss";

.cargo-advance-select-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  .el-select {
    width: 100%;

    .el-select__tags {
      flex-wrap: nowrap;

      > span {
        width: auto;
        max-width: 100%;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 8px;
        font-size: 12px;
        color: #606266;

        & > span {
          padding-left: 0;
          padding-right: 5px;
          width: 100%;
        }
      }

      input {
        min-width: 50px;
        font-size: 12px;
        margin-left: -5px;
      }
    }

    &.can-copy {
      .el-input__inner {
        padding-right: 35px !important;
      }

      .el-input__suffix {
        right: 18px !important;
      }
    }
  }

  .copy-icon {
    position: absolute;
    top: 0;
    right: 5px;
    height: 28px;
    font-size: 14px;
  }

}
.cargo-advance-select {
  &.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    top: 0!important;
  }
}

.cargo-advance-select-wrapper .el-input.is-disabled .el-input__inner::placeholder {
  color: #c0c4cc !important;
}
</style>
<style lang="scss" scoped>
.el-select-dropdown{
  .el-select-dropdown__item{
    color: #333;
    &.selected{
      color: #1F75D5;
    }
    &.hover{
      background-color: #C3CCE7;
    }
  }
}

</style>
